import { Segmented } from "antd";
import styled from "styled-components";

export const ProfileWrapper = styled.div`
  max-width: 440px;
  margin: 0 auto;
  h3 {
    font-weight: 600;
  }

  p {
    margin-bottom: 2em;
    color: var(--dark-light);
    font-size: small;
    text-transform: capitalize;
  }
`;

export const PersonalInfoWrapper = styled.div`
  width: 100%;
  margin: 2em 0;

  > div {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    /* gap: 1em; */
    margin-bottom: 1.5em;
  }

  label {
    font-size: small;
    color: var(--dark-light);
    font-weight: 400;
    margin: 0;
  }

  p {
    font-weight: 600;
    font-size: medium;
    color: var(--dark);
    margin: 0;
  }

  .mobEditRow {
    display: flex;
    align-items: center;

    svg {
      color: var(--accent);
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const PerformanceTabWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 1em;
  align-items: center;
  margin: 2em 0;
`;

export const ProfileTabWrapper = styled(Segmented)`
  label {
    margin: 0;
  }
`;
